module.exports = __webpack_public_path__ + "img/kabel_3.a070d830.webp";